(function PortSchedule($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Itineraries/portSchedule/', function onload()
		{
			$("a.info-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text($self.text());
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});

			$('a.nearby-airports').on('click', function showAirports(e) {
				e.preventDefault();
				$modal.find('.modal-title').text('Nearby Airports');
				$modal.find('.modal-body').html($("#airport-list").html());
				$modal.modal('show');
			});

			$('a.shore-excursions').on('click', function showExcursions(e)
			{
				var $self   = $(this),
				    city    = $self.data('city'),
				    city_id = $self.data('city-id');

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading shore excursions...');

				Adzuki.Ajax.get('/Excursions/getByCityId/' + city_id)
				.then(function _showExcursions(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Shore excursions for ' + city);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$(document).on('click', '.modal .info-link a', function showInfo(e) {
				e.preventDefault();
				$(this).siblings('.content').slideToggle();
			});
		});
	});

}(jQuery, window.Adzuki || {}));
